import classNames from "classnames";
import React from "react";

import strings from "../../utils/strings";

interface FooterPropsI {
	continueShopping: () => void;
	goToCart: () => void;
	canCustomerDisablePopup?: boolean;
}

export const Footer = ({ continueShopping, goToCart, canCustomerDisablePopup }: FooterPropsI) => {
	return (
		<footer className={classNames(
			"addtocart-popup__footer",
			{ "addtocart-popup__footer--can-customer-disable-popup": canCustomerDisablePopup }
		)}>
			<button
				className="addtocart-button btn btn-large tertiary-grey close-addtocart"
				data-testid="footer-button-continue"
				onClick={continueShopping}
			>
				<span>{strings.continueShopping}</span>

			</button>
			<button
				className="addtocart-button btn btn-large primary goto-cart"
				data-testid="footer-button-gotocart"
				onClick={goToCart}
			>
				<span>{strings.goToCart}</span>
			</button>
		</footer>
	);
};

